import React, { useState, useRef } from 'react';
import './MyProfile.scss';
import { ScrollView } from 'devextreme-react';
import Form, { Item, GroupItem, Label } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import { ToolbarSimple } from '../../components';
import { useAppSelector } from '../../contexts/hooks';

export default () => {
  const userInfo = useAppSelector((x) => x.userInfo.User);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [formData, setFormData] = useState({
    Us_Usuario: userInfo?.Us_Usuario || '',
    Us_Nombre: userInfo?.Us_Nombre || '',
    Us_Apellido1: userInfo?.Us_Apellido1 || '',
    Us_Apellido2: userInfo?.Us_Apellido2 || '',
    Us_Identificacion: userInfo?.Us_Identificacion || '',
    Us_Estado: userInfo?.Us_Estado || false,
    Us_FechaExpira: userInfo?.Us_FechaExpira ? new Date(userInfo.Us_FechaExpira) : null,
    Us_Foto: userInfo?.Us_Foto || null,
    Us_UltimoIngreso: userInfo?.Us_UltimoIngreso ? new Date(userInfo.Us_UltimoIngreso) : null,
  });

  const formatDate = (date) => {
    if (!date) return 'No disponible';
    return new Date(date).toLocaleString('es-CO', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handlePhotoClick = () => {
    fileInputRef.current?.click();
  };

  const resizeImage = (file: File, maxWidth: number = 300, maxHeight: number = 300, quality: number = 0.8): Promise<string> => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // Calcular nuevas dimensiones manteniendo aspecto
        let { width, height } = img;

        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
        }

        // Configurar canvas
        canvas.width = width;
        canvas.height = height;

        // Dibujar imagen redimensionada
        ctx?.drawImage(img, 0, 0, width, height);

        // Convertir a base64 con compresión
        const resizedDataUrl = canvas.toDataURL('image/jpeg', quality);
        resolve(resizedDataUrl);
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const handlePhotoChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      try {
        // Validar tipo de archivo
        if (!file.type.startsWith('image/')) {
          notify('Por favor selecciona una imagen válida', 'error', 3000);
          return;
        }

        // Validar tamaño (máximo 5MB)
        if (file.size > 5 * 1024 * 1024) {
          notify('La imagen es muy grande. Máximo 5MB permitido', 'error', 3000);
          return;
        }

        notify('Procesando imagen...', 'info', 1000);

        // Redimensionar y comprimir imagen
        const optimizedImage = await resizeImage(file, 300, 300, 0.8);

        setFormData((prev) => ({
          ...prev,
          Us_Foto: optimizedImage,
        }));

        notify('Foto actualizada exitosamente', 'success', 2000);
      } catch (error) {
        console.error('Error al procesar la imagen:', error);
        notify('Error al procesar la imagen', 'error', 3000);
      }
    }
  };

  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Mi perfil'>
        <div className='user-profile-card'>
          <div className='profile-header'>
            <div className='profile-photo-section'>
              <div className='profile-photo' onClick={handlePhotoClick}>
                {formData.Us_Foto ? (
                  <img src={formData.Us_Foto} alt='Foto de perfil' />
                ) : (
                  <div className='default-avatar'>
                    <i className='dx-icon-user' />
                  </div>
                )}
                <div className='photo-edit-overlay'>
                  <i className='dx-icon-edit' />
                </div>
              </div>
              <input ref={fileInputRef} type='file' accept='image/*' onChange={handlePhotoChange} style={{ display: 'none' }} />
            </div>
            <div className='profile-summary'>
              <h3>{`${formData.Us_Nombre} ${formData.Us_Apellido1} ${formData.Us_Apellido2}`}</h3>
              <p className='username'>@{formData.Us_Usuario}</p>
            </div>
          </div>

          <Form formData={formData} readOnly={true} showColonAfterLabel={true} labelLocation='top'>
            <GroupItem caption='Información Personal' colCount={2}>
              <Item dataField='Us_Usuario' editorType='dxTextBox'>
                <Label text='Usuario' />
              </Item>

              <Item dataField='Us_Identificacion' editorType='dxTextBox'>
                <Label text='Identificación' />
              </Item>

              <Item dataField='Us_Nombre' editorType='dxTextBox'>
                <Label text='Nombre' />
              </Item>

              <Item dataField='Us_Apellido1' editorType='dxTextBox'>
                <Label text='Primer Apellido' />
              </Item>

              <Item dataField='Us_Apellido2' editorType='dxTextBox'>
                <Label text='Segundo Apellido' />
              </Item>
            </GroupItem>
          </Form>
        </div>
      </ToolbarSimple>
    </ScrollView>
  );
};
